module.exports = __webpack_public_path__ + "img/C08TechWarElephantChampion_ua.4c33795f.webp";